export default {
  filters: {
    monthName(value) {
      switch (value) {
        case 0:
          return 'Enero';
        case 1:
          return 'Febrero';
        case 2:
          return 'Marzo';
        case 3:
          return 'Abril';
        case 4:
          return 'Mayo';
        case 5:
          return 'Junio';
        case 6:
          return 'Julio';
        case 7:
          return 'Agosto';
        case 8:
          return 'Septiembre';
        case 9:
          return 'Octubre';
        case 10:
          return 'Noviembre';
        case 11:
          return 'Diciembre';
        default:
          return '';
      }
    },
    monthNameShort(value) {
      switch (value) {
        case 0:
          return 'Ene';
        case 1:
          return 'Feb';
        case 2:
          return 'Mar';
        case 3:
          return 'Abr';
        case 4:
          return 'May';
        case 5:
          return 'Jun';
        case 6:
          return 'Jul';
        case 7:
          return 'Ago';
        case 8:
          return 'Sep';
        case 9:
          return 'Oct';
        case 10:
          return 'Nov';
        case 11:
          return 'Dic';
        default:
          return '';
      }
    },
    cabinName(value) {
      switch (value) {
        case 0:
          return 'C. V';
        case 1:
          return 'C. Cl';
        case 2:
          return 'C. S1';
        case 3:
          return 'C. S2';
        case 4:
          return 'C. P1';
        case 5:
          return 'C. P2';
        case 6:
          return 'C. PXL';
        default:
          return '';
      }
    },
    cabinNameLong(value) {
      switch (value) {
        case 1:
          return 'Casa Verde';
        case 2:
          return 'Casa Clásica';
        case 3:
          return 'Casa Superior 1';
        case 4:
          return 'Casa Superior 2';
        case 5:
          return 'Casa Premium 1';
        case 6:
          return 'Casa Premium 2';
        case 7:
          return 'Casa Premium XL';
        default:
          return '';
      }
    },
    date(value) {
      let date = new Date(value);
      date = date.getDate();
      return date;
    },
    weekDay(value) {
      let date = new Date(value);
      date = date.getDay();
      switch (date) {
        default:
          return '';
        case 0:
          date = 'Dom';
          break;
        case 1:
          date = 'Lun';
          break;
        case 2:
          date = 'Mar';
          break;
        case 3:
          date = 'Mie';
          break;
        case 4:
          date = 'Jue';
          break;
        case 5:
          date = 'Vie';
          break;
        case 6:
          date = 'Sab';
          break;
      }
      return date;
    },
    weekDayTable(value) {
      switch (value) {
        default:
          return '';
        case 0:
          return 'Dom';
          break;
        case 1:
          return 'Lun';
          break;
        case 2:
          return 'Mar';
          break;
        case 3:
          return 'Mie';
          break;
        case 4:
          return 'Jue';
          break;
        case 5:
          return 'Vie';
          break;
        case 6:
          return 'Sab';
          break;
      }
    },
    localeDateFormat(value) {
      let date = value.split('/');
      date = `${date[1]}/${date[0]}/${date[2]}`;
      return date;
    },
    breakfast(value) {
      if (value) {
        return 'SÍ';
      } return 'NO';
    },
    currencyVal(value) {
      if (value) {
        // eslint-disable-next-line
        value = value.toString();
        let arr = value.split('.');
        if (arr.length > 1) {
          if (arr[1].length > 2) {
            const secondPosition = arr[1].slice(0, 2);
            arr = `${arr[0]}.${secondPosition}`;
            return arr;
            // eslint-disable-next-line
          } else {
            arr = `${arr[0]}.${arr[1]}`;
            return arr;
          }
          // eslint-disable-next-line
        } else {
          arr = `${arr[0]}.${arr[1]}`;
          return arr;
        }
      } else {
        return value;
      }
    },
    currencyDate(date) {
      let newDate = new Date(date);
      let hour = newDate.getHours();
      let minutes = newDate.getMinutes();
      minutes = minutes.toString();
      console.log(minutes.length)
      if (minutes.length < 2) {
        minutes = `0${minutes}`
      }
      return `${hour}:${minutes}`
    },
    reservationOrigin(origin) {
      switch (origin) {
        case 0:
          return 'Airbnb';
        case 1:
          return 'Despegar';
        case 2:
          return 'Despegar';
        case 3:
          return 'Booking';
        case 4:
          return 'Expedia';
        case 5:
          return 'Extranjeros';
          break;
      }
    }
  },
};
